import { Button } from "../../Button";
import { Input } from "../../Input";
import { Modal } from "../../Modal";
import { GameSelector } from "../GameSelector";
import type { GameSummary } from "../../../types/game";

interface CreateRoomModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  displayName: string;
  onDisplayNameChange: (value: string) => void;
  displayNameError?: string;
  games: GameSummary[];
  selectedGame: string;
  defaultGame: string;
  onSelectGame: (gameId: string) => void;
  loadingGames: boolean;
  submitting: boolean;
  isAuthenticated: boolean;
}

export function CreateRoomModal({
  isOpen,
  onClose,
  onSubmit,
  displayName,
  onDisplayNameChange,
  displayNameError,
  games,
  selectedGame,
  defaultGame,
  onSelectGame,
  loadingGames,
  submitting,
  isAuthenticated,
}: CreateRoomModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Create New Room">
      <form
        onSubmit={onSubmit}
        className="space-y-6"
        data-testid="modal-create-form"
      >
        {!isAuthenticated && (
          <Input
            label="Your Name"
            value={displayName}
            onChange={(e) => onDisplayNameChange(e.target.value)}
            placeholder="Enter your display name"
            required
            maxLength={50}
            error={displayNameError}
            data-testid="modal-create-name-input"
          />
        )}

        <div>
          <label
            className="block text-sm font-bold mb-3"
            style={{ color: "var(--color-text-primary)" }}
          >
            Select a Game 🎮
          </label>
          <GameSelector
            games={games}
            selectedGame={selectedGame}
            defaultGame={defaultGame}
            onSelectGame={onSelectGame}
            loading={loadingGames}
          />
        </div>

        <div className="flex gap-4 pt-4">
          <Button
            type="submit"
            variant="success"
            disabled={submitting}
            className="flex-1"
            data-testid="modal-create-submit"
          >
            {submitting ? "Creating..." : "Create Room"}
          </Button>
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            data-testid="modal-create-cancel"
          >
            Cancel
          </Button>
        </div>
      </form>
    </Modal>
  );
}
